import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from '@app/shared/services/api/api.service';
import { CustomerComplaintCount, CustomerComplaintCountUpsertDto } from '@app/information/models/customer-complaint-counts';

@Injectable({
  providedIn: 'root'
})
export class CustomerComplaintCountsApiService extends ApiService {
  private readonly customerComplaintCountsUri = 'socrates/meters/api/customercomplaintcounts';

  constructor(public http: HttpClient) {
    super(http);
  }

  public getAll(): Observable<CustomerComplaintCount[]> {
    return this.http.get<CustomerComplaintCount[]>(this.endpoint(this.customerComplaintCountsUri));
  }

  public getByMunicipalityKey(municipalityKey: string): Observable<CustomerComplaintCount[]> {
    const uri = `socrates/meters/api/municipalities/${municipalityKey}/customerComplaintCounts`;

    return this.http.get<CustomerComplaintCount[]>(this.endpoint(uri));
  }

  public create(payload: CustomerComplaintCountUpsertDto[]): Observable<CustomerComplaintCount[]> {
    return this.http.post<CustomerComplaintCount[]>(this.endpoint(this.customerComplaintCountsUri), payload);
  }

  public patch(payload: CustomerComplaintCountUpsertDto[]): Observable<CustomerComplaintCount[]> {
    return this.http.patch<CustomerComplaintCount[]>(this.endpoint(this.customerComplaintCountsUri), payload);
  }

  public delete(customerComplaintCountGuid: string): Observable<void> {
    return this.http.delete<void>(this.endpoint(this.customerComplaintCountsUri, customerComplaintCountGuid));
  }
}
